import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { Variant } from 'antd/es/config-provider';
import clsx from 'clsx';
import React, { useState } from 'react';

interface Props {
  name?: string;
  placeholder?: string;
  value?: string;
  error?: string;
  variant?: Variant;
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export function Password({
  name = 'password',
  placeholder = 'Password',
  value,
  error,
  variant = 'outlined',
  className,
  onChange,
  onFocus,
  onBlur,
}: Readonly<Props>) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Input
      name={name}
      placeholder={placeholder}
      required
      className={clsx('h-14 rounded-2xl border-none', className)}
      size='large'
      variant={variant}
      value={value}
      type={showPassword ? 'text' : 'password'}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      suffix={
        <button
          onClick={() => setShowPassword((prev) => !prev)}
          className={`text-mediumBlue transition duration-150 ${
            value ? 'visible' : 'invisible'
          }`}
          type='button'
        >
          {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
        </button>
      }
      status={error ? 'error' : ''}
    />
  );
}
